module.exports = __webpack_public_path__ + "static/images/finance-8.882b202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-8.png
// module id = iYNc
// module chunks = 8